/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Header_BlogInputs */

const en_common_header_blog = /** @type {(inputs: Common_Header_BlogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blog`)
};

const zh_common_header_blog = /** @type {(inputs: Common_Header_BlogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`博客`)
};

/**
* | output |
* | --- |
* | "Blog" |
*
* @param {Common_Header_BlogInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_header_blog = /** @type {((inputs?: Common_Header_BlogInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Header_BlogInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_header_blog(inputs)
	return zh_common_header_blog(inputs)
});
export { common_header_blog as "common.header.blog" }